var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errors.length
    ? _c(
        "ul",
        { staticClass: "errors-messages" },
        _vm._l(_vm.errors, function(error) {
          return _c("li", [
            _vm._v("\n    " + _vm._s(_vm.$t("errors." + error)) + "\n  ")
          ])
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }